import {
  setgridheight
} from './grid-helpers';

export default function init(devGridOn_rows, devGridOn_iso, devGridOn_columns, devGridOn_baselines, devGridOn_vertlines) {
  console.log('grid/index.js');

  const toggles = document.querySelectorAll(".grid__toggle"), // various toggles avail.
        container = document.querySelector('main');

  let gridInitialInit = false;

  devGridOn_rows = false;
  devGridOn_iso = false;
  devGridOn_columns = false;
  devGridOn_baselines = false;
  devGridOn_vertlines = false;

  setgridheight(container, gridInitialInit); // update grid

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const datatoggletype = toggle.getAttribute("data-toggle-type");

      if (toggle.classList.contains("grid__layer--active")) {
        if (datatoggletype === "rows") devGridOn_rows = false;
        else if (datatoggletype === "iso") devGridOn_iso = false;
        else if (datatoggletype === "columns") devGridOn_columns = false;
        else if (datatoggletype === "baselines") devGridOn_baselines = false;
        else if (datatoggletype === "vertlines") devGridOn_vertlines = false;

        toggle.classList.remove("grid__layer--active");
        document.body.classList.remove(`grid__${datatoggletype}--active`);
      } else {
        if (datatoggletype === "rows") devGridOn_rows = true;
        else if (datatoggletype === "iso") devGridOn_iso = true;
        else if (datatoggletype === "columns") devGridOn_columns = true;
        else if (datatoggletype === "baselines") devGridOn_baselines = true;
        else if (datatoggletype === "vertlines") devGridOn_vertlines = true;

        toggle.classList.add("grid__layer--active");
        document.body.classList.add(`grid__${datatoggletype}--active`);
      }
    });
  });

  window.addEventListener('resize', function() {
    gridInitialInit = true; // already initialized
    setgridheight(container, gridInitialInit);
  });
}
